'use client';

import { cn } from '@scatterlab/zeta-core';
import { motion } from 'framer-motion';
import { memo } from 'react';

import toast, { Toast as ToastItemType } from './toastManager';

export type ToastItemProps = ToastItemType & {
  className?: string;
};

const ToastItem = ({
  id,
  message,
  subMessage,
  icon: Icon,
  onPress,
  buttonText,
  className,
  position,
  style,
  rightElement,
}: ToastItemProps) => (
  <motion.div
    role="presentation"
    key={id}
    className={cn(
      'pointer-events-auto flex w-[430px] max-w-full flex-row items-center gap-1 rounded-lg bg-black px-4 py-[15px]',
      className,
    )}
    style={style}
    onClick={() => toast.remove(id, 'button')}
    initial={{ opacity: 0, y: position === 'bottom' ? 20 : 0 }}
    animate={{ opacity: 1, y: position === 'bottom' ? 0 : 20 }}
    exit={{ opacity: 0, y: position === 'bottom' ? 20 : 0 }}
  >
    <div
      className={cn(
        'flex flex-1 gap-1.5',
        subMessage ? 'items-start' : 'items-center',
      )}
    >
      {Icon && <Icon className="w-4 text-white" />}
      <div className="flex flex-col gap-1">
        <p className="button14 text-white">{message}</p>
        {subMessage && <div className="body12 text-white/50">{subMessage}</div>}
      </div>
    </div>
    {buttonText && (
      <button
        type="button"
        onClick={(e) => {
          if (onPress) onPress(e);
          toast.remove(id, 'button');
          e.stopPropagation();
        }}
        className="button14 ml-auto text-primary-200"
      >
        {buttonText}
      </button>
    )}
    {typeof rightElement === 'function'
      ? rightElement(() => toast.remove(id, 'button'))
      : rightElement}
  </motion.div>
);

export default memo(ToastItem);
